<template>
    <div style="height: 450px;">
        <Row justify="center" style="margin-top: 50px;">
            <Col span="20" offset="2">
            <Row :gutter="16">
                <CheckboxGroup v-model="checkAllGroup" @on-change="SetCheckProps" size="large">
                    <Col v-for="(prop, index) in propList" :key="index" span="6">
                    <Checkbox :label="prop.label" size="large"></Checkbox>
                    </Col>
                </CheckboxGroup>
            </Row>
            </Col>
        </Row>
        <Row style="margin-top: 100px;" :gutter="16">
            <Col span="6" offset="18">
            <Button type="success" size="default" class="btns" shape="circle"
                @click="checkAllChange">全选</Button>          
           
           
            <Button type="primary" size="default" class="btns" shape="circle"
                @click="checkNoAllChange">全不选</Button>
            </Col>
        </Row>

    </div>
</template>
<script>


export default {
    name: "productPopupEditTabBathProductList",
    data() {
        return {        
            checkAllGroup: [],
            propList: [
                { label: '大类', prop: 'productMainCategoryUuid' },
                { label: '小类', prop: 'productSubCategoryUuid' },
                { label: '产品形态', prop: 'productForm' },
                //   { label: '品牌', prop: 'productBrandUuid' },
                { label: '颜色', prop: 'productColor' },
                { label: '纸箱', prop: 'productPackageUuid' },
                { label: '装箱量', prop: 'productPackageQuantity' },
                { label: '单位', prop: 'productUnitUuid' },
                { label: '规格', prop: 'productSpec' },
                { label: '包装费(箱/元)', prop: 'packingFee' },
                { label: '配送费(箱/元)', prop: 'deliveryFee' },
                { label: '最小单位指标', prop: 'productIncreaseStepAmount' },
                { label: '最低起订量', prop: 'productMinOrderAmount' },
                { label: '定金比例(%)', prop: 'productPreSaleDepositRatio' },
                { label: '系列', prop: 'productSerialUuid' },
                { label: '苗高(cm)', prop: 'seedlingHeight' },
                { label: '对叶数', prop: 'leavesNumber' },
                { label: '盘数(如100穴/盘)', prop: 'pottingSeedling' },
                { label: '成品图', prop: 'productFinishImageFile' },
                { label: '种苗图', prop: 'productSeedImageFile' },
                { label: '盘苗图', prop: 'productTraySeedImageFile' },
                { label: '包装图', prop: 'productPackImageFile' },
                { label: '标准卡图', prop: 'productStandardImageFile' },
                { label: '示范视频', prop: 'demonstrationVideo' },
                { label: '个性合同', prop: 'productFeatureContract' }
            ]
        };
    },
    mounted() {
        // this.init();
    },
    methods: {
        init(){
            this.checkAllChange();
            this.SetCheckProps();
        },
        SetCheckProps() {
            let props= this.propList.filter(item=>(this.checkAllGroup.includes(item.label))).map(item=>item.prop);
            this.$emit('set-props-event', props);
        },
        checkAllChange() {
            this.checkAllGroup = this.propList.map(item => item.label);
            this.SetCheckProps();
        },
        checkNoAllChange() {
            this.checkAllGroup = [];
            this.SetCheckProps();
        },
        getCheckProps(){
            return this.propList.filter(item=>(this.checkAllGroup.includes(item.label))).map(item=>item.prop);
        }
    }
};
</script>
<style scoped lang="less">
</style>